/* global axios */
import ApiClient from './ApiClient';

class MhTopicsAPI extends ApiClient {
  constructor() {
    super('mh_topics', { accountScoped: true });
  }

  badges() {
    return axios.get(`${this.url}/badges`);
  }

  reorder(data) {
    return axios.post(`${this.url}/reorder`, data);
  }

  delete(id, data) {
    return axios.delete(`${this.url}/${id}`, { data });
  }
}

export default new MhTopicsAPI();
